import { render, staticRenderFns } from "./StockReceivingLotAllocationDialog.vue?vue&type=template&id=5057a879"
import script from "./StockReceivingLotAllocationDialog.vue?vue&type=script&lang=js"
export * from "./StockReceivingLotAllocationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports